module.exports = __webpack_public_path__ + "static/media/24UHCHR18.18d030a5.jpg";